import React, { useState, useEffect } from 'react';
import child1 from '../assets/child1.webp';
import child2 from '../assets/child2.jpg';
import child3 from '../assets/child3.jpg';
import child4 from '../assets/child4.webp';
import child5 from '../assets/child6.jpg';

// Custom styles for Funding component
const styles = `
.funding-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

.funding-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Main Heading */
.funding-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 15px;
}

/* Subtitle */
.funding-subtitle {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.7;
    margin-bottom: 40px;
}

/* Carousel Container */
.funding-carousel-container {
    position: relative;
    overflow: hidden;
    margin: 0 -15px;
    padding: 0 15px;
}

.funding-carousel {
    display: flex;
    transition: transform 0.5s ease-in-out;
    gap: 25px;
}

/* Funding Card */
.funding-card {
    flex: 0 0 calc(25% - 19px);
    max-width: calc(25% - 19px);
    background-color: #F5F1E9;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
}

.funding-card-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
}

.funding-card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.funding-card-title {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.3rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 12px;
    line-height: 1.3;
    -webkit-text-stroke: 1px #5A3411;
    text-stroke: 1px #5A3411;
    paint-order: stroke fill;
    
}

.funding-card-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 0.95rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.75);
    line-height: 1.6;
    margin-bottom: 20px;
    min-height: 80px;
}

.funding-card-btn {
    background-color: #FF800D;
    color: white;
    font-family: 'Quicksand', sans-serif;
    font-size: 0.9rem;
    font-weight: 600;
    padding: 10px 25px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    margin-top: auto;
    align-self: flex-start;
}

.funding-card-btn:hover {
    background-color: #e67300;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 128, 13, 0.3);
}

/* Carousel Dots */
.funding-carousel-dots {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 30px;
}

.funding-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(90, 52, 17, 0.2);
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    padding: 0;
}

.funding-dot.active {
    background-color: #FF800D;
    transform: scale(1.2);
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .funding-section {
        padding: 70px 0;
    }
    
    .funding-heading {
        font-size: 2.5rem;
    }
    
    .funding-subtitle {
        font-size: 1.05rem;
        margin-bottom: 35px;
    }
    
    .funding-card {
        flex: 0 0 calc(33.333% - 17px);
        max-width: calc(33.333% - 17px);
    }
    
    .funding-card-image {
        height: 180px;
    }
    
    .funding-card-title {
        font-size: 1.2rem;
    }
    
    .funding-carousel {
        gap: 20px;
    }
}

@media (max-width: 991.98px) {
    .funding-section {
        padding: 60px 0;
    }
    
    .funding-heading {
        font-size: 2.2rem;
    }
    
    .funding-subtitle {
        font-size: 1rem;
        margin-bottom: 30px;
    }
    
    .funding-card {
        flex: 0 0 calc(50% - 10px);
        max-width: calc(50% - 10px);
    }
    
    .funding-card-image {
        height: 180px;
    }
    
    .funding-card-content {
        padding: 18px;
    }
    
    .funding-card-title {
        font-size: 1.15rem;
    }
    
    .funding-card-text {
        font-size: 0.9rem;
        min-height: 70px;
    }
    
    .funding-carousel {
        gap: 20px;
    }
}

@media (max-width: 767.98px) {
    .funding-section {
        padding: 50px 0;
    }
    
    .funding-heading {
        font-size: 1.8rem;
        margin-bottom: 12px;
    }
    
    .funding-subtitle {
        font-size: 0.95rem;
        margin-bottom: 25px;
    }
    
    .funding-card {
        flex: 0 0 calc(100% - 0px);
        max-width: calc(100% - 0px);
    }
    
    .funding-card-image {
        height: 200px;
    }
    
    .funding-card-content {
        padding: 20px;
    }
    
    .funding-card-title {
        font-size: 1.2rem;
    }
    
    .funding-card-text {
        font-size: 0.9rem;
        min-height: auto;
        margin-bottom: 18px;
    }
    
    .funding-carousel {
        gap: 15px;
    }
    
    .funding-carousel-dots {
        margin-top: 25px;
        gap: 8px;
    }
    
    .funding-dot {
        width: 10px;
        height: 10px;
    }
}

@media (max-width: 575.98px) {
    .funding-section {
        padding: 40px 0;
    }
    
    .funding-heading {
        font-size: 1.5rem;
    }
    
    .funding-subtitle {
        font-size: 0.9rem;
        margin-bottom: 22px;
    }
    
    .funding-card {
        border-radius: 14px;
    }
    
    .funding-card-image {
        height: 180px;
    }
    
    .funding-card-content {
        padding: 18px;
    }
    
    .funding-card-title {
        font-size: 1.1rem;
    }
    
    .funding-card-text {
        font-size: 0.85rem;
        line-height: 1.55;
    }
    
    .funding-card-btn {
        padding: 9px 22px;
        font-size: 0.85rem;
    }
}

@media (max-width: 400px) {
    .funding-section {
        padding: 35px 0;
    }
    
    .funding-heading {
        font-size: 1.3rem;
    }
    
    .funding-subtitle {
        font-size: 0.85rem;
    }
    
    .funding-card {
        border-radius: 12px;
    }
    
    .funding-card-image {
        height: 160px;
    }
    
    .funding-card-content {
        padding: 15px;
    }
    
    .funding-card-title {
        font-size: 1rem;
    }
    
    .funding-card-text {
        font-size: 0.8rem;
    }
    
    .funding-card-btn {
        padding: 8px 20px;
        font-size: 0.8rem;
    }
    
    .funding-dot {
        width: 8px;
        height: 8px;
    }
}
`;

const Funding = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [cardsToShow, setCardsToShow] = useState(4);

    const fundingData = [
        {
            image: child1,
            title: "Universal Credit",
            description: "Working families may receive funding to help with childcare costs.",
            link: "https://beststartinlife.gov.uk/childcare-early-years-education/universal-credit-childcare/"
        },
        {
            image: child2,
            title: "Tax Free Childcare",
            description: "Eligible working parents can receive a 20% government top-up on childcare fees through the Tax-Free Childcare scheme; however, this cannot be claimed alongside Universal Credit, as families must choose one option.",
            link: "https://beststartinlife.gov.uk/childcare-early-years-education/tax-free-childcare/"
        },
        {
            image: child3,
            title: "For 9 Months to 3-Year-Olds- 15 hours or 30 hours",
            description: "Eligible working families may receive funding to help with childcare costs.",
            link: "https://educationhub.blog.gov.uk/2025/09/how-to-apply-for-30-hours-free-childcare-and-find-out-if-youre-eligible/"
        },
        {
            image: child4,
            title: "Terrific Twos- 15 hours",
            description: "Gives eligible two-year-olds in Enfield up to 15 hours/week (570 hours/year) of free early education if their parents receive certain benefits.",
            link: "https://www.enfield.gov.uk/childcare-information-service/childcare-entitlements/terrific-twos#eligibility-criteria"
        },
        {
            image: child5,
            title: "For 3 – 4-Year-Olds",
            description: "All 3–4 year-olds get 15 free hours weekly, and eligible working families can receive an extra 15 hours.",
            link: "https://www.enfield.gov.uk/childcare-information-service/childcare-entitlements/terrific-twos#eligibility-criteria"
        }
    ];

    // Update cards to show based on screen size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 767) {
                setCardsToShow(1);
            } else if (window.innerWidth <= 991) {
                setCardsToShow(2);
            } else if (window.innerWidth <= 1199) {
                setCardsToShow(3);
            } else {
                setCardsToShow(4);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Auto-slide effect
    useEffect(() => {
        const totalSlides = fundingData.length;
        const maxIndex = Math.max(0, totalSlides - cardsToShow);

        const interval = setInterval(() => {
            setCurrentIndex(prev => {
                if (prev >= maxIndex) {
                    return 0;
                }
                return prev + 1;
            });
        }, 8000);

        return () => clearInterval(interval);
    }, [cardsToShow, fundingData.length]);

    const getTranslateX = () => {
        const cardWidthPercent = 100 / cardsToShow;
        const gapAdjustment = (25 * currentIndex) / cardsToShow;
        return `translateX(calc(-${currentIndex * cardWidthPercent}% - ${gapAdjustment}px))`;
    };

    const totalDots = Math.max(1, fundingData.length - cardsToShow + 1);

    return (
        <>
            <style>{styles}</style>
            <section className="funding-section">
                <div className="container">
                    <div className="funding-content-wrapper">
                        {/* Main Heading */}
                        <h2 className="funding-heading">Funding</h2>

                        {/* Subtitle */}
                        <p className="funding-subtitle">
                            Zubis Nursery supports families with childcare funding for children from 9 months and up.
                        </p>

                        {/* Carousel */}
                        <div className="funding-carousel-container">
                            <div
                                className="funding-carousel"
                                style={{ transform: getTranslateX() }}
                            >
                                {fundingData.map((item, index) => (
                                    <div key={index} className="funding-card">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="funding-card-image"
                                        />
                                        <div className="funding-card-content">
                                            <h5 className="funding-card-title">{item.title}</h5>
                                            <p className="funding-card-text">{item.description}</p>
                                            <a href={item.link} target='_blank' className="funding-card-btn">Learn More</a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Carousel Dots */}
                        <div className="funding-carousel-dots">
                            {Array.from({ length: totalDots }).map((_, index) => (
                                <button
                                    key={index}
                                    className={`funding-dot ${currentIndex === index ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(index)}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Funding;
